/* eslint-disable @typescript-eslint/no-magic-numbers */
export const MAP_MARKER_ICON_SIZE = [40, 40];
export const MAP_MARKER_ICON_ANCHOR = [12, 31];
export const MAP_MARKER_POPUP_ANCHOR = [0, -8];
export const MAP_MARKER_CLUSTER_ICON_SIZE = [40, 40];
export const MAP_MARKER_CLUSTER_RADIUS_MAX = 50;

export const MAP_DEFAULT_ZOOM = 10;
export const MAP_FULLSCREEN_CONTROL_SELECTOR = '.dg-control-round__icon.dg-control-round__icon_name_fullscreen';
export const MAP_CLUSTER_GROUP_CLASSNAME = 'marker-cluster__custom';
